<template>
  <div>
    <div class="modalBackColor" :class="{ result_open: clickResult }"></div>
    <!-- [모달창]실적 상세정보-->
    <div class="modal_wrap h80 modal_no230" data-modal="230" :class="{ result_open: clickResult }">
      <div class="modal_title user">
        <p>{{ $t("mypage.referralDetailInfo") }}</p>
        <div class="mdcolsebtn" @click="closeResult"></div>
      </div>
      <div class="modal_content">
        <!---->
        <div class="referral_detail_wrap">
          <!--A그룹(좌측)-->
          <div class="group_box">
            <h3>
              <span class="gn">{{ $t("mypage.leftGroup") }}</span>
            </h3>
            <ul>
              <li>
                <span class="day">{{ $t('mypage.total') }}</span>
                <span class="value stress">${{ recommendList.leftRecord }}</span>
              </li>
              <li>
                <span class="day">{{ $t("mypage.daily") }}</span>
                <span class="value">
                  <i></i>
                  <em class="num">${{ recommendList.leftDailyRecord }}</em>
                </span>
              </li>
              <!--팀마이너: class=minus 추가-->
              <li :class="{
                minus: recommendNum[0].leftWeek < recommendNum[0].rightWeek,
              }">
                <span class="day">{{ $t("mypage.weekly") }}</span>
                <span class="value">
                  <i>Team minus</i>
                  <em class="num">${{ recommendList.leftWeeklyRecord }}</em>
                </span>
              </li>
              <li :class="{
                minus: recommendNum[0].leftMonth < recommendNum[0].rightMonth,
              }">
                <span class="day">{{ $t("mypage.monthly") }}</span>
                <span class="value">
                  <i>Team minus</i>
                  <em class="num">${{ recommendList.leftMonthlyRecord }}</em>
                </span>
              </li>
            </ul>
          </div>
          <!--B그룹(우측)-->
          <div class="group_box">
            <h3>
              <span class="gn">{{ $t("mypage.rightGroup") }}</span>
            </h3>
            <ul>
              <li>
                <span class="day">{{ $t('mypage.total') }}</span>
                <span class="value stress">${{ recommendList.leftRecord }}</span>
              </li>
              <li>
                <span class="day">{{ $t("mypage.daily") }}</span>
                <span class="value">
                  <i></i>
                  <em class="num">${{ recommendList.rightDailyRecord }}</em>
                </span>
              </li>
              <li :class="{
                minus: recommendNum[0].leftWeek > recommendNum[0].rightWeek,
              }">
                <span class="day">{{ $t("mypage.weekly") }}</span>
                <span class="value">
                  <i>Team minus</i>
                  <em class="num">${{ recommendList.rightWeeklyRecord }}</em>
                </span>
              </li>
              <li :class="{
                minus: recommendNum[0].leftMonth > recommendNum[0].rightMonth,
              }">
                <!--팀마이너: class=minus 추가-->
                <span class="day">{{ $t("mypage.monthly") }}</span>
                <span class="value">
                  <i>Team minus</i>
                  <em class="num">${{ recommendList.rightMonthlyRecord }}</em>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- [모달창]실적 상세정보:End -->
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "ResultDetail",
  data() {
    return {
      leftWeek: this.recommendList.leftWeeklyRecord,
    };
  },
  emits: ['getDashboard'],
  computed: {
    ...mapState("user", ["clickResult"]),
  },
  props: {
    recommendList: Object,
    recommendNum: Object,
  },
  methods: {
    ...mapMutations("user", ["changeResult"]),

    closeResult() {
      this.changeResult({ state: false });
      this.$emit('getDashboard');

    },
  },

};
</script>

<style scoped>
.result_open {
  display: block;
}
</style>
